define('config/pages',['require','chaplin'],function(require) {
    'use strict';

    var Chaplin = require('chaplin');

    return [
        { name: 'dashboard', title: 'Обзор', action: 'dashboard#show', mainMenu: true,
            roles: ['new', 'normal']
        },

        { name: 'news/:newsId', title: 'Просмотр новости', action: 'news#item',
            roles: ['new', 'normal'] },
        { name: 'news', title: 'Новости', action: 'news#list', mainMenu: true,
            routes: [
                { pattern: 'news-list/:tag' },
                { pattern: 'news-list', options: { params: { tag: '' } }}
            ],
            roles: ['new', 'normal']
        },
        { name: 'schedule', title: 'Торги', action: 'schedule#show', mainMenu: true,
            routes: [
                { pattern: 'schedule/:date' },
                { pattern: 'schedule', options: { params: { date: '' } }}
            ],
            roles: ['new', 'normal']
        },
        { name: 'claims', title: 'Претензии', action: 'claims#show', mainMenu: true,
            routes: [
                { pattern: 'claims/:fromDate/:toDate' },
                { pattern: 'claims' }
            ],
            roles: ['normal']
        },
        { name: 'claim', title: 'Претензии', action: 'claims#item', parent: 'claims',
            routes: [
                { pattern: 'claims/:claimId' }
            ],
            roles: ['new', 'normal']
        },
        { name: 'basket', title: 'Корзина', action: 'basket#show', mainMenu: true, status: 0,
            roles: ['new', 'normal'] },
        { name: 'requests', title: 'Заказы', action: 'requests#show', mainMenu: true,
            routes: [
                { pattern: 'requests/:fromDate/:toDate' },
                { pattern: 'requests' }
            ],
            roles: ['new', 'normal']
        },
        { name: 'favorites', title: 'Избранное', action: 'favorites#show', mainMenu: true,
            routes: [
                { pattern: 'favorites/:page/:favFilter' },
                { pattern: 'favorites/:page', options: { params: { favFilter: 'favs' } } },
                { pattern: 'favorites', options: { params: { page: 'providers', favFilter: 'favs' } }}
            ],
            roles: ['new', 'normal']
        },
        { name: 'wishlist', title: 'Пожелания', action: 'wishlist#show', mainMenu: true, status: 0,
            routes: [
                { pattern: 'wishlist/:page/:type' },
                { pattern: 'wishlist/:page', options: { params: { type: 'active' } } },
                { pattern: 'wishlist', options: { params: { page: 'wishes', type: 'active' } } },
                { pattern: 'wishlist-wishes', options: { params: { page: 'wishes', type: 'active' } } },
                { pattern: 'wishlist-offers', options: { params: { page: 'offers', type: 'active' } } }
            ],
            roles: ['new', 'normal'] },
        { name: 'organization', title: 'Компания', action: 'organization#show', mainMenu: true,
            routes: [
                { pattern: 'organization/:page' },
                { pattern: 'organization', options: { params: { page: 'settings'} }},
                { pattern: 'organization/', options: { params: { page: 'settings'} }}
            ],
            roles: ['new', 'normal']
        },
        { name: 'account-main', title: 'Счет', action: 'account#main',
            routes: [
                { pattern: 'account/main/:fromDate/:toDate' },
                { pattern: 'account/main', options: { params: { fromDate: '', toDate: '' } }}
            ],
            roles: ['normal']
        },
        { name: 'packs', title: 'Товар', action: 'packs#show',
            routes: [
                { pattern: 'packs/:tradeId', options: { params: { currency: 'view' } }}
            ],
            roles: ['new', 'normal']
        },
        { name: 'packs-view', title: 'Товар', action: 'packs#showView',
            routes: [
                { pattern: 'packs/:tradeId/view' }
            ],
            roles: ['new', 'normal']
        },
        { name: 'packs-base', title: 'Товар', action: 'packs#showBase',
            routes: [
                { pattern: 'packs/:tradeId/base' }
            ],
            roles: ['new', 'normal']
        },
        { name: 'trade', title: 'Торги', action: 'trade#show',
            routes: [
                { pattern: 'trade/:page/:tradeId/:state' },
                { pattern: 'trade/:page/:tradeId', options: { params: { state: 'om' } }}
            ],
            roles: ['new', 'normal']
        },
        { name: 'user', title: 'Профиль пользователя', action: 'user#show',
            routes: [
                { pattern: 'user/:userId', options: { params: { page: 'details' } } },
                { pattern: 'user/:userId/', options: { params: { page: 'details' } } },
                { pattern: 'user/:userId/:page' }
            ],
            roles: ['new', 'normal']
        },
        { name: 'multi-account', title: 'Мультисчет', action: 'multi-account#show',
            routes: [
                { pattern: 'multi-account/:currencyCode' },
                { pattern: 'multi-account' }
            ],
            roles: ['new', 'normal']
        }
    ];
});
